import React, { useEffect, useState } from "react";
import "./styles.css";
import Button from "../../Elements/Buttons/Button";
import rect1 from "../../../Assets/Images/login-rectangle-1.png";
import rect2 from "../../../Assets/Images/login-rectangle-2.png";
import { login as loginService } from "../../../Services";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../Context/AuthContext";
import Navbar1 from "../../Elements/Navbar1/index.js";
import { IoEarth } from "react-icons/io5";
const Login = () => {
  const [onFocus, setOnFocus] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { user, login } = useAuth();

  const handleLogin = async () => {
    try {
      setError(null);
      const data = await loginService(email, password);
      // console.log(data);
      // Update user information in AuthContext
      login(data);
      navigate("/dashboard");
    } catch (error) {
      if (error.response) {
        setError(error.response.data.message);
      }
    }
  };

  useEffect(() => {
    if (user) {
      navigate("/dashboard");
    }
  }, []);

  return (
    <div className="login-page">
      {/* logo */}
      <Navbar1 />
      {/* <h2 className="h2-600 blue" style={{ alignSelf: "flex-start" }}>
        OncoCharts
      </h2> */}
      {/* main login input container */}
        <div className="tagline-container" style={{ textAlign: "center" }}>
            <div>
          <h1 className="h3-600 blue" style={{ marginBottom: "0px", color: "black" }}>
            <span style={{color: "green"}} >on</span><span style={{ color: "#3058A6"}}>COCHARTS</span> is a data driven, tech-enabled platform <br/> providing timely insights in cancer care. 
          </h1>
          {/* <h5 style={{ color: "gray" }}> 
            Login to manage your patients seamlessly and securely - anytime, anywhere from any device - available on web as well as mobile.
            </h5> */}
          </div>
        </div>
            
      <div className="login-body">
        {/* left side marketing copy */}
        <div className="login-copy">
          <p className="dark-grey">
            <span className="brand-blue">COCHARTING</span> is our propreitary
            process of integrating data generated from clinical trials and
            real-world patient data and bringing insights at the point of cancer
            care.
          </p>
          <p className="dark-grey">
            <span className="brand-green">on</span>
            <span className="brand-blue">COCHARTS</span> helps save time for
            clinicians in cancer hospitals and improve outcomes in cancer.
          </p>
        </div>

        <div className="login-container">
        {/* <h1 className="h1-400 dark-grey">Welcome!</h1> */}
        {/* <p className="dark-grey">Login here with your registered Email</p> */}
        {}
        <div className="input-container">
          {/* <label className={onFocus ? "label-focus" : "label"}>Email</label> */}
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            // onFocus={() => setOnFocus(true)}
            // onBlur={(event) => {
            //   if (event.target.value === "") setOnFocus(false);
            // }}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div className="error-container">
          {error && <p className="body3 error-message">{error}</p>}
        </div>

        {/* <a
          className="body3"
          style={{
            cursor: "pointer",
            textDecoration: "none",
            alignSelf: "flex-end",
          }}
          href="/"
        >
          Recover Password
        </a> */}

        <Button btnType="login" onClick={handleLogin} />
        <p className="body1 dark-grey" style={{ textAlign: "center" }}>
          To create an account, contact at us
          support@oncocharts.com
        </p>
        </div>
      </div>
      {/* footer blue images */}
      <div
        className="footer-bg-img"
        style={{
          background: `url(${rect1}) no-repeat center top / cover, url(${rect2}) no-repeat center top / cover`,
        }}
      ></div>
      
      {/* footer content */}
      <div className="footer">
        <div className="login-footer-address">
          <p className="white body1-600">i3 Partners GmbH</p>
          <p>In den Steinreben 4d</p>
          <p>4153 Reinach BL</p>
          <p>Switzerland</p>
          <p className="login-footer-website">
            <IoEarth size={14} />
            <a
              href="https://www.i3partners.net/"
              target="_blank"
              rel="noreferrer"
            >
              www.i3partners.net
            </a>
          </p>
        </div>
        <p className="light-blue login-footer-copyright">
          Copyright 2022  {" "}
          <span>&#169;</span> {" "}
          <span className="white body1-600 ">i3 Partners GmbH</span>
        </p>
        {/* <p className="light-blue">Terms And Conditions</p>
        <p className="light-blue">Privacy Policy</p> */}
      </div>
    </div>
  );
};

export default Login;
